import Form from "../form";

class Validator {
	constructor(el, type, elInfo) {
		this._init(el, type, elInfo)
	}
	_init(el, type, elInfo) {
		this.el = el
		this.elInfo = elInfo
		if(!this.el) {
			return
		}
		this.type = type
		this.name = this.el.dataset.validatorName
		switch(type) {
			case "maxlength":
				this.validator = new MaxLengthValidator(this)
				break
			case "minlength":
				this.validator = new MinLengthValidator(this)
				break
			case "empty":
				this.validator = new NotEmptyValidator(this)
				break
			case "email":
				this.validator = new EmailValidator(this)
				break
			case "number":
				this.validator = new NumberValidator(this)
				break
			case "radio":
				this.validator = new RadioValidator(this)
				break
			case "radio-field":
				this.validator = new RadioFieldValidator(this)
				break
			case "nif":
				this.validator = new NIFValidator(this)
				break;
			case "optional-nif":
				this.validator = new NIFValidator(this, true)
				break;
			case "":
				break
			default:
				throw 'not implemented'
		}
	}
	validate() {
		if (this.validator == undefined) {
			return true
		}
		return this.validator.validateFunc(this.el.value)
	}
	updateInfo(string) {
		this.elInfo.innerHTML = string
	}
}
// #region MaxLengthValidator
class MaxLengthValidator {
	constructor(manager) {
		this._init(manager)
	}
	_init(manager) {
		this.manager = manager
		let error = document.querySelector('[data-validator-length-error]')
		this.manager.maxLength = this.manager.el.getAttribute('maxlength')
		this.manager.error =  error ? this.setErrorMessage(error) : "Não pode ser tão longo."
		this.manager.validateFunc = this.validateFunc
	}
	validateFunc(value) {
		return !(value.length > this.maxLength);
	}
	setErrorMessage(elError) {
		let array = elError.dataset.validatorMaxError.split('%s')
		array[2] = this.manager.name
		array[4] = this.manager.maxLength
		return array.join()
	}
}
// #endregion
// #region MinLengthValidator
class MinLengthValidator {
	constructor(manager) {
		this._init(manager)
	}
	_init(manager) {
		this.manager = manager
		let error = document.querySelector('[data-validator-length-error]')
		this.manager.error =  error ? this.setErrorMessage(error) : "Não pode ser tão curto."
		this.manager.minLength = this.manager.el.getAttribute('minlength')
		this.manager.validateFunc = this.validateFunc
	}
	validateFunc(value) {
		return !(value.length < this.minLength);
	}
	setErrorMessage(elError) {
		let array = elError.dataset.validatorMaxError.split('%s')
		array[2] = this.manager.name
		array[4] = this.manager.minLength
		return array.join()
	}
}
// #endregion
// #region NotEmptyValidator
class NotEmptyValidator {
	constructor(manager) {
		this._init(manager)
	}
	_init(manager) {
		this.manager = manager
		let error = document.querySelector('[data-validator-empty-error]')
		this.manager.error =  error ? error.dataset.validatorEmptyError.replace('%s', this.manager.name) : "Não pode estar vazio."
		this.manager.validateFunc = this.validateFunc
	}
	validateFunc(value) {
		return value.trim() != '';
	}
}
// #endregion
// #region EmailValidator
class EmailValidator {
	constructor(manager) {
		this._init(manager)
	}
	_init(manager) {
		this.manager = manager
		let error = document.querySelector('[data-validator-invalid-error]')
		this.manager.error =  error ? error.dataset.validatorInvalidError.replace('%s', this.manager.name) : "Email tem de ser válido."
		this.manager.validateFunc = this.validateFunc
	}
	validateFunc(value) {
		return /^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/.test(value);
	}
}
// #endregion
// #region NumberValidator
class NumberValidator {
	constructor(manager) {
		this._init(manager)
	}
	_init(manager) {
		this.manager = manager
		this.manager.validateFunc = this.validateFunc
		let error = document.querySelector('[data-validator-invalid-error]')
		this.manager.error =  error ? error.dataset.validatorInvalidError.replace('%s', this.manager.name) : "Número tem de ser válido."
	}
	validateFunc(value) {
		// return /^\d+$/.test(value);
		return /^(\d+(-{1,1})?( {1,1})?)*$/.test(value);
	}
}
// #endregion
// #region RadioValidator
class RadioValidator {
	constructor(manager) {
		this._init(manager)
	}
	_init(manager) {
		this.manager = manager
		this.manager.validateFunc = this.validateFunc
		let error = document.querySelector('[data-validator-invalid-error]')
		this.manager.error =  error ? error.dataset.validatorInvalidError.replace('%s', this.manager.name) : "Escolha tem de ser válida."
	}
	validateFunc() {
		return this.manager.el.checked && !this.manager.el.disabled;
	}
}
// #endregion
// #region RadioFieldValidator
class RadioFieldValidator {
	constructor(manager) {
		this._init(manager)
	}
	_init(manager) {
		this.manager = manager
		this.manager.validateFunc = this.validateFunc
		let error = document.querySelector('[data-validator-invalid-error]')
		this.manager.error =  error ? error.dataset.validatorInvalidError.replace('%s', this.manager.name) : "Formulário tem de ser válido."
		this.manager.form = new Form(this.manager.el, "extra");
	}
	validateFunc() {
		if(this.el.checked) {
			return this.form.checkValidation()
		}
		return false;
	}
}

// #endregion
// #endregion
// #region RadioFieldValidator
class NIFValidator {
	constructor(manager, optional = false) {
		this._init(manager)
		this.optional = optional
	}
	_init(manager) {
		this.manager = manager
		this.manager.validateFunc = this.validateFunc
		let error = document.querySelector('[data-validator-invalid-error]')
		this.manager.error =  error ? error.dataset.validatorInvalidError.replace('%s', this.manager.name) : "NIF tem de ser válido."
		this.manager.form = new Form(this.manager.el, "extra");
	}
	validateFunc(nif) {
		if (this.optional && nif == '') {
			return true
		}

		if(!['1', '2', '3', '5', '6', '8'].includes(nif.substr(0,1)) &&
		   !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(nif.substr(0,2)))
			return false;

		let total = nif[0] * 9 + nif[1] * 8 + nif[2] * 7 + nif[3] * 6 + nif[4] * 5 + nif[5] * 4 + nif[6] * 3 + nif[7] * 2;

		let modulo11 = total - parseInt(total / 11) * 11;
		let comparador = modulo11 == 1 || modulo11 == 0 ? 0 : 11 - modulo11;

		return nif[8] == comparador
	}
}
// #endregion

export default Validator